
import { DashboardKeys } from '@/i18n/types/dashboard.types';

export const dashboard: Record<DashboardKeys, string> = {
  overdueTasks: 'Overdue Tasks',
  todayTasks: 'Tasks Due Today',
  specialDates: 'Special Dates',
  todaySchedule: "Today's Schedule",
  todayPayments: "Today's Payments",
  todayIncome: "Today's Income",
  overdueDebts: 'Overdue Debts',
  todayDebts: "Today's Debts",
  noOverdueTasks: 'No overdue tasks',
  noTodayTasks: 'No tasks for today',
  noSpecialDates: 'No special dates today',
  noScheduledEvents: 'No scheduled events',
  noOverdueDebts: 'No overdue debts',
  noTodayDebts: 'No debts due today',
  loadingTasks: 'Loading tasks...',
  selectMonth: 'Select month',
  specialDateDeleted: 'Special date deleted successfully',
  errorDeletingSpecialDate: 'Error deleting special date',
  noTodayPayments: 'No payments for today',
  noIncome: 'No income for today',
  goals: 'Goals',
  activeGoals: 'Active Goals',
  noActiveGoals: 'No active goals',
  habitsToday: 'Today\'s Habits',
  dailyHabits: 'Daily Habits',
  noHabitsToday: 'No habits for today',
  calendarAndEvents: 'Calendar & Events',
  financeOverview: 'Finance Overview',
  reminders: 'Reminders',
  overdueReminders: 'Overdue Reminders',
  todayReminders: 'Today\'s Reminders',
  upcomingReminders: 'Upcoming Reminders',
  noOverdueReminders: 'No overdue reminders',
  noTodayReminders: 'No reminders for today',
  noUpcomingReminders: 'No upcoming reminders',
  tasksAndGoals: 'Tasks & Goals',
};
